import { render, staticRenderFns } from "./release-authorizations.page.vue?vue&type=template&id=6ae83172&"
import script from "./release-authorizations.page.vue?vue&type=script&lang=ts&"
export * from "./release-authorizations.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports